export const DATA = {
  projects: [
    {
      imgpath:
        "https://res.cloudinary.com/de9qkjreb/image/upload/v1789369495/kaya_ssb6ex.png",
      title: "Kaya Beta Journals",
      tags: "UX Design, Product Design",
      context: "Academic, 2024",
      linkpath: "/Kaya",
      blurb:
        "Reimagining KAYA’s climbing experience to help climbers log, reflect on, and progress through every session.",
    },
    {
      imgpath:
        "https://res.cloudinary.com/de9qkjreb/image/upload/v1758850094/icon_tqhdvy.png",
      title: "YVR Airport",
      tags: "Visual Design",
      context: "Internship, 2024",
      linkpath: "/YVRAirport",
      blurb:
        "8 month internship as a Content & Design Co-op with the Vancouver Airport Authority in the design team.",
    },

    {
      imgpath:
        "https://res.cloudinary.com/de9qkjreb/image/upload/v1758679656/Icon_olfdvn.png",
      title: "Tough Titties Gallery",
      tags: "UX Design",
      context: "Hackathon, 2024",
      linkpath: "/toughtittiesgallery",
      blurb:
        "An interactive safe space for customers to share their unique titties as well as their stories. 4th place out of 128.",
    },
    {
      imgpath:
        "https://res.cloudinary.com/de9qkjreb/image/upload/v1758847082/Cover_jb3ikv.png",
      title: "Tinder Date Requests",
      tags: "UX/UI Design",
      context: "Academic, 2023",
      linkpath: "/Tinder",
      blurb:
        "Creating more comfortable offline interactions by giving users control over when to receive date requests and an easy way to say no.",
    },
    {
      imgpath:
        "https://res.cloudinary.com/de9qkjreb/image/upload/v1749861589/Microsite_nuflzh.jpg",
      title: "The Ways of Water",
      tags: "Art Direction, Interaction Design",
      context: "Academic, 2022",
      linkpath: "/Water",
      blurb:
        "An immersive and expressive microsite for a group exhibition connecting water and humankind.",
    },
  ],
};
